module.exports = __webpack_public_path__ + "static/media/backend.b37d8446.svg";